module.exports = __webpack_public_path__ + "static/media/time.5e7f5e86.svg";